import React from 'react';

import LoadingBox from '../../shared/LoadingBox';

import WizardSearchCustomerForm from '../../trade/wizard/WizardSearchCustomerForm';
import DepositInfoScreen from './DepositInfoScreen'
import IncomingPaymentForm from '../../deal/IncomingPaymentForm'
//import DealUse from './DealUse'

import {getCurrencyList} from '../../../networking/NetworkingCurrencies';
import {getLookUpTable} from '../../../networking/Networking';

import {getStyle} from '../../../styles/styles';
var style = getStyle();

export default class DepositsScreen extends React.Component {
   state={    
       objCustomer: {},
        step: 1,
        listIncomingInstruments : [],
        listActiveCurrencies : [],
        objDeposit: {},
        typeRecordsApply : 'Deposit'
   }

   componentDidMount()
   {
        this.loadCurrencyList();
        this.loadIncomingInstruments();
   }

   onClickStepTab = (value) => {
        if(this.state.step === 1){
            //Nothing at all
        }
        else{
            if(value === 4)
            { 
                if(this.state.objDeposit !== undefined && this.state.objDeposit["Deposit ID"] !== undefined)
                {
                    this.setState({step: value});
                }
            }
            else
            {
                this.setState({step: value});
            }
        }
    }

    handleBackLink = ()=> {
        this.props.backLink();
    }

    ///Customer screen
    handleCustomerSelection(obj, nextStep){
        if(nextStep === 2){            
            this.setState({step: nextStep, 
                objCustomer: obj
            });            
        }  
    }

    ///Deposit screen
    handleDepositSelection(obj, nextStep){
        if(nextStep === 4){            
            this.setState({
                objDeposit: obj
            });            
        }  
    }

    loadCurrencyList() {
        getCurrencyList().then(
            (response) => {
                if (typeof response !== "undefined") {
                    let currencies = response.currencies;
                    currencies.forEach(element => {
                        element.value = element.CurrencyID;
                        element.name = element.CurrencyIDName;
                    });
                    this.setState({
                        listActiveCurrencies: currencies
                    });
                }
            }
        );
    }

    loadIncomingInstruments() {
        getLookUpTable('Incoming Instruments').then(
            (response) => {
                if (typeof response !== "undefined" && response.lookUpTables !== "undefined") {
                    let instruments = response.lookUpTables[0];
                    instruments.lookUpTableDetails.forEach(element => {
                        element.value = element.LookUpTableDetail;
                        element.name = element.LookUpTableDetail;
                    });
                    var listInstruments = [];
                    listInstruments.push(instruments);
                    this.setState({
                        listIncomingInstruments: listInstruments
                    });                    
                }
            });
    }

    render()
    {
        
        var button = "";
        
        if(this.props.data !== undefined)
        { 
            button = <button className="uk-button uk-button-text uk-margin-right" onClick={this.handleBackLink}>
        <i className="fa fa-arrow-left" style={{ fontSize: '1.75em', verticalAlign: 'middle'  }}></i>
                    </button>;
        }

        var stepScreen = [];

        var classNameStep1 = '', classNameStep2 = '', classNameStep3 = '';//, classNameStep4 = '';

        switch(this.state.step){
            case 1:
            default:
                classNameStep1 = 'uk-active';
                stepScreen.push(<WizardSearchCustomerForm key="customer-form"
                    onCustomerSelected={this.handleCustomerSelection.bind(this)}/>);
                break;
            case 2:
                classNameStep2 = 'uk-active';
                stepScreen.push(<DepositInfoScreen key="deposit-form"
                    objCustomer={this.state.objCustomer} currencies ={this.state.listActiveCurrencies}
                    onDepositSelected={this.handleDepositSelection.bind(this)}/>);
                break;
            case 3:
                classNameStep3 = 'uk-active';
                stepScreen.push(<IncomingPaymentForm key="payment-form"
                customerID={this.state.objCustomer["Customer ID"]}
                activeCurrencies={this.state.listActiveCurrencies}
                incomingInstruments={this.state.listIncomingInstruments}
                typeRecordsApply = {this.state.typeRecordsApply}
                paymentOpenFromBoard={false}/>);
                break;
          /*  case 4:
                classNameStep4 = 'uk-active';
                stepScreen.push(<DealUse key="deposit-form"
                        objDeposit={this.state.objDeposit}
                        customerID={this.state.objCustomer["Customer ID"]}/>);
                break;*/
        }
      return(

        
        <div>
            <h3 className="uk-heading-divider" style={style.titleStyle}>            
                {button}
                Deposits</h3>
            
            <div>
                
                <ul className="uk-tab">
                    <li className={classNameStep1}><a onClick={() => this.onClickStepTab(1)}>Search Customer</a></li>
                    <li className={classNameStep2}><a onClick={() => this.onClickStepTab(2)}>Deposits</a></li>
                    <li className={classNameStep3}><a onClick={() => this.onClickStepTab(3)}>Incoming Payments</a></li>
                   
                </ul>
                {stepScreen}

                <LoadingBox loading={this.state.loading}/>
            </div>
        </div>
      );
    }
}